// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/integration.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateIntegrationRequest, CreateIntegrationResponse, DeleteIntegrationRequest, DeleteIntegrationResponse, GetIntegrationRequest, GetIntegrationResponse, ListIntegrationsRequest, ListIntegrationsResponse, TestIntegrationRequest, TestIntegrationResponse, UpdateIntegrationRequest, UpdateIntegrationResponse } from "./integration_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.IntegrationService
 */
export const IntegrationService = {
  typeName: "tracker.v1.IntegrationService",
  methods: {
    /**
     * @generated from rpc tracker.v1.IntegrationService.ListIntegrations
     */
    listIntegrations: {
      name: "ListIntegrations",
      I: ListIntegrationsRequest,
      O: ListIntegrationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.IntegrationService.GetIntegration
     */
    getIntegration: {
      name: "GetIntegration",
      I: GetIntegrationRequest,
      O: GetIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.IntegrationService.CreateIntegration
     */
    createIntegration: {
      name: "CreateIntegration",
      I: CreateIntegrationRequest,
      O: CreateIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.IntegrationService.UpdateIntegration
     */
    updateIntegration: {
      name: "UpdateIntegration",
      I: UpdateIntegrationRequest,
      O: UpdateIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.IntegrationService.DeleteIntegration
     */
    deleteIntegration: {
      name: "DeleteIntegration",
      I: DeleteIntegrationRequest,
      O: DeleteIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.IntegrationService.TestIntegration
     */
    testIntegration: {
      name: "TestIntegration",
      I: TestIntegrationRequest,
      O: TestIntegrationResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

